export default "__VITE_ASSET__CmL5zvVg__"